import { PrimeReactProvider } from 'primereact/api'
import { ConfirmDialog } from 'primereact/confirmdialog'
import React from 'react'
import ReactDOM from 'react-dom/client'
import '~/App.css'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter } from 'react-router-dom'
import AppPages from './AppPages'
import { LanguageProvider } from './contexts/LanguageContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { ToastProvider } from './hooks/toast'

const queryClient = new QueryClient()
const root = document.getElementById('root')
if (root)
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <PrimeReactProvider>
        <ToastProvider>
          <LanguageProvider>
            <QueryClientProvider client={queryClient}>
              <NotificationProvider>
                <BrowserRouter>
                  <AppPages />
                  <ConfirmDialog />
                </BrowserRouter>
              </NotificationProvider>
            </QueryClientProvider>
          </LanguageProvider>
        </ToastProvider>
      </PrimeReactProvider>
    </React.StrictMode>,
  )
